import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { ITransformOptions } from '../../models/query/transforms';
import { BaseTransform } from './BaseTransform';
import { PivotTransform } from './PivotTransform';
import { CollectionTransform } from './CollectionTransform';
import { AliasTransform } from './AliasTransform';
import { CaseTransform } from './CaseTransform';
import { SplitTransform } from './SplitTransform';
import { TranslationHelper } from '../../helpers/TranslationHelper';
import { FilterTransform } from './FilterTransform';
import { ConditionalTransform } from './ConditionalTransform';
import { SwitchTransform } from './SwitchTransform';
import { NumberTransform } from './NumberTransform';
import { VisibleTransform } from './VisibleTransform';
import { TrimTransform } from './TrimTransform';
import { RenameFieldTransform } from './RenameFieldTransform';
import { ObjectTransform } from './ObjectTransform';
import { QueryTransform } from './QueryTransform';
import { MapTransform } from './MapTransform';
import { FormatTransform } from './FormatTransform';
import { GroupTransform } from './GroupTransform';
import { RegexTransform } from './RegexTransform';
import { ReplaceTransform } from './ReplaceTransform';

export class Transform {
	constructor(public options: ITransformOptions, public translationHelper: TranslationHelper, public callStackLevel?: number) {

	}
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		const { transformOptionsType } = this.options;
		let transform: BaseTransform | undefined;
		if (transformOptionsType) {
			switch (transformOptionsType) {
				case 'pivot':
					transform = new PivotTransform(this.options, this.translationHelper);
					break;
				case 'collection':
					transform = new CollectionTransform(this.options, this.translationHelper);
					break;
				case 'alias':
					transform = new AliasTransform(this.options, this.translationHelper);
					break;
				case 'case':
					transform = new CaseTransform(this.options, this.translationHelper);
					break;
				case 'split':
					transform = new SplitTransform(this.options, this.translationHelper);
					break;
				case 'filter':
					transform = new FilterTransform(this.options, this.translationHelper);
					break;
				case 'conditional':
					transform = new ConditionalTransform(this.options, this.translationHelper);
					break;
				case 'switch':
					transform = new SwitchTransform(this.options, this.translationHelper);
					break;
				case 'number':
					transform = new NumberTransform(this.options, this.translationHelper);
					break;
				case 'visible':
					transform = new VisibleTransform(this.options, this.translationHelper);
					break;
				case 'trim':
					transform = new TrimTransform(this.options, this.translationHelper);
					break;
				case 'renameField':
					transform = new RenameFieldTransform(this.options, this.translationHelper);
					break;
				case 'object':
					transform = new ObjectTransform(this.options, this.translationHelper, this.callStackLevel);
					break;
				case 'query':
					transform = new QueryTransform(this.options, this.translationHelper, this.callStackLevel);
					break;
				case 'map':
					transform = new MapTransform(this.options, this.translationHelper, this.callStackLevel);
					break;
				case 'format':
					transform = new FormatTransform(this.options, this.translationHelper, this.callStackLevel);
					break;
				case 'group':
					transform = new GroupTransform(this.options, this.translationHelper);
					break;
				case 'regex':
					transform = new RegexTransform(this.options, this.translationHelper);
					break;
				case 'replace':
					transform = new ReplaceTransform(this.options, this.translationHelper);
					break;
				default:
					transform = undefined;
					break;
			}
			if (transform) {
				const transformResponse = transform.execute(queryResponse, queryOptions, executionOptions);
				return transformResponse;
			}
		}
	}
}